import {API, ApiResponseBase, CustomAxiosError} from "../../../../../logics/api-config";
import {ICashTransactionsDetail} from "../../../../../utils/interfaces/Accounting/Recap/ICashTransactionsDetail";
import {useQuery, UseQueryResult} from "react-query";


export interface ApiResponse extends ApiResponseBase {
    data: ICashTransactionsDetail[];
}

async function doGet(ris_id: number, year: string, month: string): Promise<ICashTransactionsDetail[]> {
    const response = await API.get(`/accounting/recap/restaurant/${ris_id}/cash_transactions/${year}/${month}`);
    return response?.data.data;
}

const useApiGetCashTransactionsDetail = (
    ris_id: number,
    year: string,
    month: string,
    options: any = {}
): UseQueryResult<ICashTransactionsDetail[], CustomAxiosError> => {
    return useQuery<ICashTransactionsDetail[], CustomAxiosError>(
        ["getCashTransactionsDetail", ris_id, year, month],
        () => doGet(ris_id, year, month),
        { ...options }
    );
};

export default useApiGetCashTransactionsDetail;